import React from 'react';
import { Navbar, Nav, NavDropdown, Form, FormControl, Button } from 'react-bootstrap'
import SearchBar from '../SearchBar';
import './index.css';

const NavBar = (props) => {
    return (
        <Navbar bg="light" expand="lg">
            <Navbar.Brand href="#"><img src={"./logo.png"} alt={"Logo"} /> </Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse id="navbarScroll">
                <Nav
                className="mr-auto my-2 my-lg-0"
                style={{ maxHeight: '100px' }}
                navbarScroll
                >
                    <Nav.Link href="/">Home</Nav.Link>
                    {/* <Nav.Link href="#action2">Link</Nav.Link>
                    <NavDropdown title="Link" id="navbarScrollingDropdown">
                        <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
                        <NavDropdown.Item href="#action4">Another action</NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item href="#action5">Something else here</NavDropdown.Item>
                    </NavDropdown>
                    <Nav.Link href="#" disabled>
                        Link
                    </Nav.Link> */}
                </Nav>
                <SearchBar onSubmit={props.onSubmit} />
            </Navbar.Collapse>
        </Navbar>
    )
}

export default NavBar;